import React from 'react'

import s from './styles.module.scss'

import Contact from './contact/Contact'
import OwnerCurrentAction from './footer/owner-current-action/OwnerCurrentAction'
import { IUploadQuotationProps } from './footer/owner-current-action/upload-quotation-modal/UploadQuotationModal'
import OwnerBrief from './owner-brief/OwnerBrief'
import Tips from './tips/Tips'
import { CompanyInformationClientRequestFragment } from '../../../../lib/graphql'
import { HorizontalSeparator } from '../../../atoms'
import { Container } from '../../../layout'
import { IProposalInteractionsProps } from '../../../organisms/proposal/Proposal'

const CompanyInformation = ({
  clientRequest,
  ownerActions,
  uploadQuotationData,
}: {
  clientRequest: CompanyInformationClientRequestFragment
  ownerActions: IProposalInteractionsProps['ownerActions']
  uploadQuotationData?: IUploadQuotationProps
}) => {
  if (!clientRequest.clientProposal) {
    return null
  }

  return (
    <Container className={s.container}>
      <Contact clientRequest={clientRequest} />

      <HorizontalSeparator className={s.separator} />

      <OwnerBrief briefOwner={clientRequest.briefOwner ?? ''} />

      {clientRequest.clientProposal?.ownerCurrentAction && (
        <Tips
          className={s.tips}
          clientProposalOwnerCurrentAction={
            clientRequest.clientProposal?.ownerCurrentAction
          }
        />
      )}

      <OwnerCurrentAction
        ownerActions={ownerActions}
        uploadQuotationData={uploadQuotationData}
        clientRequest={clientRequest}
      />
    </Container>
  )
}

export default CompanyInformation
